import React, { useState, useEffect } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import GasolinaDocument from './GasolinaDocument';
import { IconButton, Modal, Box } from '@mui/material';
import { Print, Close } from '@mui/icons-material';
import axios from 'axios';

const GasolinaPDF = ({ vale }) => {
  const [open, setOpen] = useState(false);
  const [shipment, setShipment] = useState(null);
  const [fullVale, setFullVale] = useState({ ...vale });

  const handleOpen = () => {
    fetchShipmentDetails();
    setOpen(true);
  };
  
  const handleClose = () => setOpen(false);

  const fetchShipmentDetails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/shipments?reference=${vale.shipment}`);
      
      if (response.data && response.data.length > 0) {
        const shipmentData = response.data[0];
        setShipment(shipmentData);
        
        // Get destination city from first order
        let destinationCity = 'No especificado';
        if (shipmentData.orders && shipmentData.orders.length > 0) {
          destinationCity = shipmentData.orders[0].City || 'No especificado';
        }
        
        setFullVale({
          ...vale,
          origen: shipmentData.origin || vale.origen || 'No especificado',
          destino: destinationCity || vale.destino || 'No especificado',
          driver: shipmentData.driver || 'No especificado',
          vehicle: shipmentData.vehicle || 'No especificado'
        });
      }
    } catch (error) {
      console.error('Error fetching shipment details:', error);
    }
  };

  return (
    <>
      <IconButton color="primary" onClick={handleOpen}>
        <Print />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '80%',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <PDFDownloadLink
              document={<GasolinaDocument vale={fullVale} />}
              fileName={`vale-gasolina-${vale.folio}.pdf`}
            >
              {({ blob, url, loading, error }) =>
                loading ? 'Preparando documento...' : 'Descargar PDF'
              }
            </PDFDownloadLink>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <PDFViewer width="100%" height="90%">
            <GasolinaDocument vale={fullVale} />
          </PDFViewer>
        </Box>
      </Modal>
    </>
  );
};

export default GasolinaPDF;
